// Message text as WhatsApp shows it: *bold* and _italic_ on a single line, no
// nesting, newlines kept. Built as React nodes, so nothing is parsed as HTML.
import { Fragment, type ReactNode } from 'react';

// A marker pair that hugs its text and isn't inside a word (so snake_case and 2*3*4 stay as typed).
const MARK = /(?<![\w*])\*(?=\S)([^*\n]*?\S)\*(?![\w*])|(?<![\w_])_(?=\S)([^_\n]*?\S)_(?![\w_])/g;

function line(text: string, key: string): ReactNode[] {
  const out: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(MARK)) {
    const at = m.index ?? 0;
    if (at > last) out.push(text.slice(last, at));
    out.push(m[1] !== undefined ? <strong key={`${key}-${at}`}>{m[1]}</strong> : <em key={`${key}-${at}`}>{m[2]}</em>);
    last = at + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export function ChatText({ text }: { text: string }) {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((l, i) => (
        <Fragment key={i}>
          {line(l, String(i))}
          {i < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
}
